import { useMutation } from '@tanstack/react-query';
import {
  generateReport,
  reportToCSV,
  downloadCSV,
  type ReportFilters,
  type ReportData,
} from '@/services/reports';

// ===========================================
// Mutation Hooks
// ===========================================

/**
 * Generate a report
 */
export function useGenerateReport() {
  return useMutation({
    mutationFn: (filters: ReportFilters) => generateReport(filters),
  });
}

/**
 * Export report to CSV
 */
export function useExportCSV() {
  return useMutation({
    mutationFn: async ({
      report,
      filename,
    }: {
      report: ReportData;
      filename: string;
    }) => {
      const csv = reportToCSV(report);
      downloadCSV(csv, filename);
    },
  });
}

// Re-export types and helpers
export {
  getCurrentQuarterRange,
  getPreviousQuarterRange,
  getYTDRange,
  getQuarterLabel,
} from '@/services/reports';

export type { ReportFilters, ReportData, ReportSummary } from '@/services/reports';
